import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { InputLabel, InputLabelProps } from './InputLabel';
import { InputErrorMessage } from '../../inputMessages';

export const InputContainerProps = {
  suffix: PropTypes.string,
  ...InputLabelProps,
  children: PropTypes.node,
  isValid: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export const InputContainer = ({
  suffix,
  label,
  id,
  children,
  isValid,
  errorMessage,
}) => {
  return (
    <>
      <Container suffix={suffix}>
        {label && <InputLabel htmlFor={id} label={label} />}
        {children}
      </Container>
      {isValid === false && errorMessage && (
        <InputErrorMessage>{errorMessage}</InputErrorMessage>
      )}
    </>
  );
};

InputContainer.propTypes = {
  ...InputContainerProps,
};

export const Container = styled.div`
  display: inline-block;
  position: relative;

  &:after {
    display: block;
    position: absolute;
    right: 20px;
    bottom: 0.6rem;
    color: ${(props) => props.theme.textSecondaryColor};
    content: '${(props) => props.suffix}';
  }
`;
